import React from 'react';
import SiteHeader from './SiteHeader';

class HomeWindow extends React.Component {

    render() {
        return (
            <>
                <SiteHeader />
            </>
        );
    }
}

export default HomeWindow;